import { useGetOSEndOfLifeQuery } from '@/redux/slices/deviceReportingApiSlice';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { PermissionEnum } from '@electricjs/core_entity-client';
import { useUserHasOrganizationPermission } from '@/hooks/useUserHasOrganizationPermission';
import { skipToken } from '@reduxjs/toolkit/query';

export const useGetOSEndOfLife = ({
  skip = false,
}: { skip?: boolean } = {}) => {
  const organizationId = useGetOrganizationId();
  const hasDeviceReadPermission = useUserHasOrganizationPermission(
    PermissionEnum.Devicesread
  );

  const result = useGetOSEndOfLifeQuery(
    hasDeviceReadPermission && !skip
      ? {
          organizationId,
        }
      : skipToken
  );

  return result;
};
